const notificationsState = BX.Vue3.reactive({
    items: [],
    _id: 0
});

export const notify = (Title, Message, Type = 'info', duration = 4000) => {
    const item = {
            id: notificationsState._id++,
            title: Title,
            message: Message,
            type: Type
        };
    notificationsState.items.push(item);

    if (duration > 0) {
        setTimeout(() => {
                const i = notificationsState.items.findIndex(n => n.id === item.id);
                if (i !== -1) notificationsState.items.splice(i, 1);
            }, duration);
    }
};

notify.success = (Title, Message) => notify(Title, Message, 'success');
notify.error   = (Title, Message) => notify(Title, Message, 'error', 0);
notify.info    = (Title, Message) => notify(Title, Message, 'info');



export const Notifications = {
    data () {
        return {
            notifications: notificationsState.items
        }
    },
    methods: {
        removeNotification (id) {
            const i = this.notifications.findIndex(n => n.id === id);
            if (i !== -1) this.notifications.splice(i, 1);
        }
    },
    template: /* vue-html */`
    <section class="notifications-container">
        <article 
                v-for="n in notifications"
                :key="n.id"
                :class="'notification notification-' + n.type"
                class="notification notification-error"
            >
            <div class="flex items-start gap-4 px-5 py-5">
                <div class="notification-icon">

                    <svg v-if="n.type == 'error'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" class="h-5 w-5" aria-hidden="true">
                        <path d="M12 8v5"></path>
                        <path d="M12 16h.01"></path>
                        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"></path>
                    </svg>

                    <svg v-if="n.type == 'success'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" class="h-5 w-5" aria-hidden="true">
                        <path d="m5 12 5 5L20 7"></path>
                    </svg>

                    <svg v-if="n.type == 'info'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" class="h-5 w-5" aria-hidden="true">
                        <path d="M12 8h.01"></path>
                        <path d="M11 12h1v4h1"></path>
                        <path d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z"></path>
                    </svg>

                    
                </div>
                <div class="min-w-0 flex-1 pr-12 sm:pr-0">
                    <div class="flex items-start gap-4 sm:gap-4">
                        <div class="flex-1 min-w-0">
                            <p v-if="false" class="text-sm font-semibold uppercase tracking-[0.18em] text-[color:var(--color-error)]">Ошибка</p>
                            <h2 
                                    v-if="n.title"
                                    class="mt-1 text-lg font-bold text-ink"
                                    v-html="n.title"
                                ></h2>
                        </div>
                        <button 
                                type="button" 
                                aria-label="Закрыть" 
                                class="notification-close-btn flex items-center justify-center rounded-full border border-line bg-soft text-muted leading-none aspect-square p-0 transition hover:bg-white absolute top-3 right-3 sm:relative sm:top-auto sm:right-auto"
                                :class="'hover:border-[color:var(--color-'+n.type+')]/30'"
                                @click="removeNotification(n.id)"
                            >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" class="h-4 w-4" aria-hidden="true">
                                <path d="M18 6 6 18"></path>
                                <path d="m6 6 12 12"></path>
                            </svg>
                        </button>
                    </div>
                    <p
                            v-if="n.message" 
                            class="mt-2 text-sm leading-6 text-muted"
                            v-html="n.message"
                        ></p>
                </div>
            </div>
            <div :class="'h-1.5 w-full bg-[color:var(--color-'+n.type+')]'"></div>
        </article>
    </section>
    `
};